import React, { Component } from 'react';

import { SelectLanguages } from 'components/input/select';
import Loader from 'components/loader/Loader';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

@inject((stores) => ({
  supportedLanguages: stores.SubtitleStore.supportedTranscriptionLangs
}))
@observer
export default class SubtitleSupportedTranscriptionLangs extends Component {
  static propTypes = {
    supportedLanguages: PropTypes.array,
    mediaId: PropTypes.string
  };

  hasSupportedLanguages() {
    const { supportedLanguages: langs, mediaId } = this.props;

    return langs && langs[mediaId] && langs[mediaId].length;
  }

  render() {
    const { supportedLanguages, mediaId, ...props } = this.props;

    if (this.hasSupportedLanguages()) {
      return (
        <SelectLanguages languages={supportedLanguages[mediaId]} {...props} />
      );
    }

    return <Loader></Loader>;
  }
}
